export const VIRTUAL_PROVIDER = "VIRTUAL" as const;

/** Default flat-rate fee (USD) charged for Virtual dropoff when no fee is stored on the draft return. */
export const DEFAULT_VIRTUAL_DROPOFF_FEE_USD = 5;
/** Default flat-rate fee (USD) charged for Blue Yonder dropoff when no fee is stored on the draft return. */
export const DEFAULT_BLUE_YONDER_DROPOFF_FEE_USD = 6;
export const RETURN_BEAR_PROVIDER = "RETURN_BEAR" as const;
export const BLUE_YONDER_PROVIDER = "BLUE_YONDER" as const;

export const dropoffProviderType = [
  VIRTUAL_PROVIDER,
  RETURN_BEAR_PROVIDER,
  BLUE_YONDER_PROVIDER,
  // "HAPPY_RETURNS",
] as const;
export type DropoffProviderType = (typeof dropoffProviderType)[number];

const merchantFacingProviderNames: Record<DropoffProviderType, string> = {
  VIRTUAL: "Virtual",
  RETURN_BEAR: "ReturnBear",
  BLUE_YONDER: "FedEx Easy Returns",
};

export function getMerchantFacingProviderName(
  provider: DropoffProviderType,
): string {
  return merchantFacingProviderNames[provider];
}
